import { render } from "./DepartmentJobsView.vue?vue&type=template&id=a6ceb8e2&scoped=true"
import script from "./DepartmentJobsView.vue?vue&type=script&lang=js"
export * from "./DepartmentJobsView.vue?vue&type=script&lang=js"

import "./DepartmentJobsView.vue?vue&type=style&index=0&id=a6ceb8e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6ceb8e2"]])

export default __exports__